import { useState } from "react";
import { useSelector } from "react-redux";
import { Grid, TextField, Card, DialogTitle, DialogContent, IconButton, Typography, DialogActions } from "@mui/material";
// icons
import { grey } from '@mui/material/colors';
import CloseIcon from '@mui/icons-material/Close';
// utils and helpers
import { numberOnly } from "utilities/common";
// custom components
import MDButton from "components/MDButton";

export default function AssignQtyToDriver({ closeModal }) {
    const { modalData } = useSelector(state => state.modal || {});
    const { setBulkQuantity = () => { } } = modalData || {};

    const [values, setValues] = useState({});
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues(prev => ({ ...prev, [name]: numberOnly(value) }));
    }

    const handleSave = async () => {
        if (!Number(values.drivers)) {
            setErrors({ drivers: "Quantity is required" });
            return;
        } else {
            setErrors({});
        }

        setBulkQuantity(values);
        closeModal();
    };

    return (
        <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
            <DialogTitle id='draggable-dialog-title' sx={{ p: 0, mb: 4 }} display='flex' alignItems='center' justifyContent='space-between'>
                Assign Qty Per Driver
                <IconButton onClick={closeModal} edge='end' size='small' className='modal-close'>
                    <CloseIcon fontSize='medium' />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} >
                        <Typography variant='body2' fontWeight="medium" color={grey[600]} mb={1}>Enter Quantity Per Driver</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            className="form-input created-by p-l-field bg-transparent"
                            placeholder="Enter Quantity Per Driver"
                            name="drivers"
                            value={values?.drivers || ""}
                            onChange={handleChange}
                        />
                        {errors?.drivers && <p className="error">{errors?.drivers}</p>}
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions style={{ justifyContent: "center" }}>
                <MDButton
                    color="primary"
                    type="button"
                    variant="contained"
                    onClick={handleSave}
                >
                    Save
                </MDButton>
                <MDButton
                    onClick={closeModal}
                    type='button'
                    variant='outlined'
                    color='dark'
                >
                    Cancel
                </MDButton>
            </DialogActions>
        </Card>
    )
}